import Quotes from "./quotes.svg";

export default Quotes;
